module.exports = __webpack_public_path__ + "static/media/who-5.cd1c253e.jpg";